// extracted by mini-css-extract-plugin
export default {"container":"ClaimReward_container__uVoI-"};